import type { VisualizationKind } from './VisualizationKind';

/**
 * Поле дочірньої таблиці, за яким діаграма розкладає записи (прототип v4 vizVals): причини fishbone — за категорією, елементи SWOT — за
 * SWOT-категорією, стратегії TOWS — за комбінацією, тези брифінгу — за видом тези.
 */
export const VIZ_FIELDS: Readonly<Record<VisualizationKind, string>> = { fishbone: 'fcat', swot: 'sw', tows: 'combo', briefing: 'mkind' };
